
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-sbl-email',
  standalone: true,
  imports: [FormsModule, DividerModule, ButtonModule, SharedModule],
  templateUrl: './sbl-email.component.html',
  styleUrl: './sbl-email.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SblEmailComponent {
  isNormalMessageVisible:boolean = true;
  isAcceptMessageVisble:boolean = false;
  isRejectMessageVisble:boolean = false;

  acceptPraposal(){
    this.isNormalMessageVisible = false;
    this.isAcceptMessageVisble = true;
    this.isRejectMessageVisble = false;
  }
  rejectPraposal() {
    this.isNormalMessageVisible = false;
    this.isAcceptMessageVisble = false;
    this.isRejectMessageVisble = true;
  }

}
